export const patientObject = {
  fullName: '',
  cognitoId: '',
  id: '',
  createdAt: '',
  lastSession: '',
  userId: '',
  totalCredits: 0,
  totalSessions: 0,
  patientAttention: false,
  notifiesRenewal: false,
};

export const DEFAULT_MINIMUM_INVITE_TIME = '1';
